import { SITE_ID } from './constants'
import { hostnameBySiteId } from './constants/hostnames'
import siteIdByCountryId from './constants/site-id-by-country-id'

export const ghostLink = ({ url, target = '_self' }) => {
  const link = document.createElement('a')
  link.target = target
  link.href = url
  link.click()
}

export const download = (dataurl, filename) => {
  const a = document.createElement('a')
  a.href = dataurl
  a.setAttribute('download', filename)
  a.click()
  return false
}

export const getSiteIdByCountryId = (id) => siteIdByCountryId.find((item) => item.id === id)?.siteId
export const getCountryIdBySiteId = (id) => siteIdByCountryId.find((item) => item.siteId === id)?.id

export const getSiteEnviroment = (idPais) => {
  const siteId = getSiteIdByCountryId(idPais)
  const currentCountry = hostnameBySiteId[siteId || 'BMAR']
  const requestedHostname: string = window.location.hostname
  // default value AR: somethig goes wrong or maybe hostaname == localhost?
  let siteEnviroment = 'local'
  if (currentCountry) {
    const siteSuffix: string = currentCountry.hostnameSuffix
    if (requestedHostname.endsWith(siteSuffix)) {
      // Get the "site enviroment" part of hostname example www in www.bumeran.com.ar
      siteEnviroment = requestedHostname.slice(0, -siteSuffix.length)
    }
  }
  return siteEnviroment
}

export const getSiteUrl = (hostnameSuffix, siteEnviroment) => {
  const requestedProtocol = window.location.protocol
  const requestedPort = window.location.port
  let portFragment
  // Avoid include default ports
  if (
    (requestedProtocol === 'http' && requestedPort === '80') ||
    (requestedProtocol === 'https' && requestedPort === '443')
  ) {
    portFragment = ''
  } else {
    portFragment = `:${requestedPort}`
  }
  return `${requestedProtocol}//${siteEnviroment}${hostnameSuffix}${portFragment}/empresas`
}

export const getSiteUrlBySiteId = (siteId: string) => {
  const currentHostname = hostnameBySiteId[SITE_ID || 'BMAR']
  const newHostname = hostnameBySiteId[siteId]
  const url = new URL(window.location.href)
  url.hostname = url.hostname.replace(currentHostname, newHostname)
  return url
}

export const getSiteUrlByCountryId = (countryId: number) => {
  const siteId = getSiteIdByCountryId(countryId)
  return getSiteUrlBySiteId(siteId || 'BMAR')
}

export const hexToRgb = (hex: string) =>
  hex
    ?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
    ?.substring(1)
    ?.match(/.{2}/g)
    ?.map((x) => parseInt(x, 16))

export const escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const matchRule = (str: string, rule: string) => {
  return new RegExp('^' + rule.split('*').map(escapeRegex).join('.*') + '$').test(str)
}

export function until<T>(conditionFunction: () => T, millis = 400) {
  const poll = (resolve) => {
    const value = conditionFunction()
    if (value) resolve(value)
    else setTimeout(() => poll(resolve), millis)
  }

  return new Promise<T>(poll)
}

export const getCookieData = (key: string, cookieString: string) => {
  if (!cookieString) return null
  const data = cookieString.split(`${key}=`)
  if (!data[1]) return null
  const value = data[1].split(';')[0]
  if (value && value.length) return value
  return null
}

export function setCookieData(key: string, value: string, seconds?: number) {
  const expirationDate = seconds ? `Max-Age=${seconds};` : ''
  document.cookie = `${key}=${value}; ${expirationDate} path=/`
}

export const transformToNumber = (value: string | number) => {
  return typeof value !== 'number' ? Number(value?.replace(/\D/g, '')) : value
}

export const compareObjects = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2)

export function truncateText(text, length, delimiter = '...') {
  return text.length > length ? text.substr(0, length) + delimiter : text
}

export const removeDiacritics = (text: string) => {
  text = text.trim().toLowerCase()
  text = replaceAll(text, ',', '')
  text = replaceAll(text, ' ', '-')
  text = replaceAll(text, '\\(', '')
  text = replaceAll(text, '\\)', '')
  text = replaceAll(text, '/', '-')
  text = replaceAll(text, '\\+', '')
  text = replaceAll(text, '#', '')
  text = replaceAll(text, '¿', '')
  text = replaceAll(text, '\\?', '')
  text = replaceAll(text, "'", '')
  text = replaceAll(text, '%', '')
  text = replaceAll(text, '|', '')
  text = replaceAll(text, '¡', '')
  text = replaceAll(text, '!', '')
  text = replaceAll(text, '"', '')
  text = replaceAll(text, '<', '')
  text = replaceAll(text, '>', '')
  text = replaceAll(text, '`', '')

  text = replaceAll(text, '-+', '-')
  text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  text = replaceAll(text, 'p{InCombiningDiacriticalMarks}+', '')
  text = replaceAll(text, '\\P{Print}', '') //remove non-printable characters
  return text
}

export const removeDiacriticsConEnie = (text: string, esUrl: boolean = false) => {
  text = text.trim().toLowerCase()
  text = replaceAll(text, ',', '')
  text = replaceAll(text, '%c3%b1', 'ñ')
  text = replaceAll(text, '%c3%91', 'ñ')
  text = replaceAll(text, '%c3%a1', 'a') // á
  text = replaceAll(text, '%c3%81', 'A') // Á
  text = replaceAll(text, '%c3%a9', 'e') // é
  text = replaceAll(text, '%c3%89', 'E') // É
  text = replaceAll(text, '%c3%ad', 'i') // í
  text = replaceAll(text, '%c3%8d', 'I') // Í
  text = replaceAll(text, '%c3%93', 'O') // Ó
  text = replaceAll(text, '%c3%b3', 'o') // ó
  text = replaceAll(text, '%c3%ba', 'u') // ú
  text = replaceAll(text, '%c3%9a', 'U') // Ú
  text = replaceAll(text, '%20', '-')
  text = replaceAll(text, ' ', '-')
  text = replaceAll(text, '(', '')
  text = replaceAll(text, ')', '')
  text = replaceAll(text, '+', '')
  text = replaceAll(text, '#', '')
  text = replaceAll(text, '¿', '')
  text = replaceAll(text, '?', '')
  text = replaceAll(text, "'", '')
  text = replaceAll(text, '%', '')
  text = replaceAll(text, '|', '')
  text = replaceAll(text, '¡', '')
  text = replaceAll(text, '!', '')
  text = replaceAll(text, '"', '')
  text = replaceAll(text, '<', '')
  text = replaceAll(text, '>', '')
  text = replaceAll(text, '`', '')
  text = replaceAll(text, '[', '')
  text = replaceAll(text, ']', '')
  text = replaceAll(text, '{', '')
  text = replaceAll(text, '}', '')

  text = replaceAll(text, '-+', '-')

  if (!esUrl) text = text.replace('/', '-')

  text = text.replace('ñ', '\\001')
  text = text.normalize('NFD')
  text = replaceAll(text, '[\\p{InCombiningDiacriticalMarks}]', '')
  text = text.replace('\\001', 'ñ')

  return text
}

export const compareWithoutDiacritics = (a: string, b: string) => {
  const a_ = removeDiacritics(a)
  const b_ = removeDiacritics(b)
  return a_ != null ? (a_ == b_ ? true : false) : false
}

export const removeCharactersNonPrintable = (text: string) => {
  text = removeDiacritics(text)
  text = replaceAll(text, '\\+', '\\-')
  text = replaceAll(text, '(-+)', '-')
  return text
}

export const capitalizeFirstCharacter = (a: string): string => {
  let cadena
  if (a) cadena = a.substring(0, 1).toUpperCase() + a.substring(1).toLowerCase()

  return cadena
}

export const replaceAll = (target: string, search: string, replacement: string) => {
  return target.replace(new RegExp(search, 'g'), replacement)
}

export const compareNumbers = (...numbers) => {
  const [first, second, ...others] = numbers
  const firstNumber = parseInt(first, 10)
  const secondNumber = parseInt(second, 10)
  if (others?.length > 0) {
    return compareNumbers(first, second) && compareNumbers(second, ...others)
  }
  if (!!firstNumber && !secondNumber) {
    return true
  }
  if (!!firstNumber && !!secondNumber) {
    return firstNumber === secondNumber
  }
  return false
}

export const setAvisoFormJobiData = (data) => sessionStorage.setItem('avisoFormJobiData', JSON.stringify(data))

export const getAvisoFormJobiData = () => JSON.parse(sessionStorage.getItem('avisoFormJobiData') || 'null')

export const clearAvisoFormJobiData = () => sessionStorage.removeItem('avisoFormJobiData')